import {
    REQUEST_FORGOT_PASSWORD,
    SAVE_FORGOT_PASSWORD,
    SAVE_FORGOT_PASSWORD_FAIL,
    REQUEST_SAVE_TEMP_TOKEN,
    SAVE_TEMP_TOKEN,
    SAVE_TEMP_TOKEN_FAIL,
    REQUEST_UPDATE_NEWPASSWORD,
    SAVE_UPDATE_NEWPASSWORD,
    SAVE_UPDATE_NEWPASSWORD_FAIL,
    SHOW_ALERT_FORGOT_PASSWORD
} from '../constants/userConstants';

export const forgotPasswordReducers = ( state = { 
        emailSend: false, 
        emailSendError : null, 
        temToken: null,
        temTokenError : null,
        passwordUpdated : null,
        showAlert : false,
        alertType : null , 
        alertMsg: "",
    },  action
)=> {
	switch (action.type) {
		case REQUEST_FORGOT_PASSWORD:
			return {
				...state,
				loading: true,
			};
        case SAVE_FORGOT_PASSWORD:
            return {
                ...state,
                loading: false,
                emailSend : action.payload
            };
        case SAVE_FORGOT_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                emailSendError: action.payload,
            };
		case REQUEST_SAVE_TEMP_TOKEN:
			return {
				...state,
				loading: true,
            };
        case SAVE_TEMP_TOKEN:
			return {
				...state,
				loading: false,
				temToken: action.payload,
			};
		case SAVE_TEMP_TOKEN_FAIL:
			return {
				...state,
				loading: false,
				temTokenError: action.payload,
            };
        case REQUEST_UPDATE_NEWPASSWORD:
            return {
                ...state,
                loading: true,
            };
        case SAVE_UPDATE_NEWPASSWORD:
            return {
                ...state,
                loading: false,
                passwordUpdated: action.payload,
            };
        case SAVE_UPDATE_NEWPASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                passwordUpdatedError: action.payload,
            };
        case SHOW_ALERT_FORGOT_PASSWORD:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
		default:
			return state;
	}
};
